import * as Yup from 'yup';

export const validationSchemaContact = Yup.object().shape({
  leadSourceId: Yup.string().required('Lead Source is required'),

  //   phone: Yup.string()
  //   .nullable()
  //  .test(
  //   "is-valid-phone",
  //   "Phone number is Invalid",
  //   (value) => {
  //     // Allow empty value (optional field)
  //     if (!value) return true;

  //     // Check if the value contains only valid characters and is at most 20 characters long
  //     return /^[0-9+\-]{1,20}$/.test(value);
  //   }
  // )
  // .max(20, "Phone number cannot exceed 20 characters"),

  // lastName: Yup.string().required('Last Name is required'),

  linkedin: Yup.string()
    .nullable()
    .test('is-valid-linkedin', 'LinkedIn URL must be a valid LinkedIn profile URL', (value) => {
      if (!value) return true;
      // Convert to lowercase for case-insensitive validation
      const lowerValue = value.toLowerCase();
      return /^(https?:\/\/)?(www\.)?linkedin\.com\/[\w@.-]+.*$/.test(lowerValue);
    }),
  facebook: Yup.string().test(
    'is-valid-facebook',
    'Facebook URL must be a valid Facebook profile URL',
    (value) => {
      if (!value) return true; // Allow empty value
      // Convert to lowercase for case-insensitive validation
      const lowerValue = value.toLowerCase();
      return /^(https?:\/\/)?(www\.)?facebook\.com\/[\w@.-]+.*$/i.test(lowerValue);
    }
  ),
  twitter: Yup.string().test(
    'is-valid-twitter',
    'Twitter URL must be a valid Twitter profile URL',
    (value) => !value || /^(https?:\/\/)?(www\.)?(twitter|x)\.com\/[\w@.-]+.*$/i.test(value)
  ),
  skype: Yup.string().test(
    'is-valid-skype',
    'Skype ID must be valid',
    (value) => !value || /^[a-zA-Z0-9._-]{6,32}$/.test(value)
  ),

  firstName: Yup.string()
    .nullable()
    .trim()
    .max(50, 'First Name must not exceed 50 characters')
    .test(
      'valid-format',
      'Please enter valid name',
      (value) =>
        !value ||
        (/^[A-Za-z0-9\s\-']+$/.test(value) && // Only alphabets, numbers and allowed special chars
          !/(\s{2,}|-{2,}|'{2,})/.test(value) && // No consecutive spaces or special chars
          !/^[-'\s]|[-'\s]$/.test(value)) // No leading/trailing special chars
    ),

  middleName: Yup.string()
    .nullable()
    .trim()
    .max(50, 'Middle Name must not exceed 50 characters')
    .test(
      'valid-format',
      'Please enter valid name',
      (value) =>
        !value ||
        (/^[A-Za-z0-9\s\-']+$/.test(value) && // Only alphabets, numbers and allowed special chars
          !/(\s{2,}|-{2,}|'{2,})/.test(value) && // No consecutive spaces or special chars
          !/^[-'\s]|[-'\s]$/.test(value)) // No leading/trailing special chars
    ),

  lastName: Yup.string()
    .required('Last Name is required')
    .trim()
    .max(50, 'Last Name must not exceed 50 characters')
    .test(
      'valid-format',
      'Please enter valid name',
      (value) =>
        !value ||
        (/^[A-Za-z0-9\s\-']+$/.test(value) && // Only alphabets, numbers and allowed special chars
          !/(\s{2,}|-{2,}|'{2,})/.test(value) && // No consecutive spaces or special chars
          !/^[-'\s]|[-'\s]$/.test(value)) // No leading/trailing special chars
    ),

  title: Yup.string()
    .nullable()
    .trim() // Trim leading and trailing spaces
    .max(100, 'Title cannot exceed 100 characters')
    .test('is-valid-title', 'Title contains invalid characters or formatting', (value) => {
      if (!value) return true; // Allow blank input
      // Ensure only valid characters and no consecutive spaces or special characters
      return /^[A-Za-z0-9\s-'.,/&]+$/.test(value) && !/( {2,}|[-'.,/&]{2,})/.test(value);
    }),

  street: Yup.string()
    .nullable()
    .trim() // Automatically trim leading and trailing spaces
    .max(100, 'Street cannot exceed 100 characters.')
    .test('valid-characters', 'Invalid characters in street.', (value) => {
      if (!value) return true; // Allow blank input
      // Regex to validate allowed characters and ensure no consecutive special characters or spaces
      return /^[A-Za-z0-9 ,.#/'-]+$/.test(value) && !/( {2,}|[,.#/'-]{2,})/.test(value);
    }),

  // email: Yup.string()
  // .nullable()
  // .test(
  //   "is-valid-email",
  //   "Invalid email format",
  //   (value) => {
  //     if (!value) return true;
  //     // More comprehensive email validation
  //     // 1. Username can contain letters, numbers, dots, hyphens, and underscores
  //     // 2. Domain must have valid TLD and cannot have consecutive dots
  //     // 3. TLD must be at least 2 characters
  //     return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/.test(value) &&
  //            !value.includes('..') && // No consecutive dots
  //            !/\.{2,}/.test(value.split('@')[1]); // No consecutive dots in domain
  //   }
  // ),
  email: Yup.string()
    .nullable()
    .test('is-valid-email', 'Invalid email format', (value) => {
      if (!value) return true; // Allow empty
      return Yup.string().email().isValidSync(value);
    }),

  // secondaryEmail: Yup.string()
  // .nullable()
  // .test(
  //   "is-valid-email",
  //   "Invalid email format",
  //   (value) => {
  //     if (!value) return true;
  //     // Use the same comprehensive validation for secondary email
  //     return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/.test(value) &&
  //            !value.includes('..') && // No consecutive dots
  //            !/\.{2,}/.test(value.split('@')[1]); // No consecutive dots in domain
  //   }
  // ),
  secondaryEmail: Yup.string()
    .nullable()
    .test('is-valid-email', 'Invalid email format', (value) => {
      if (!value) return true; // Allow empty
      return Yup.string().email().isValidSync(value);
    }),

  // phone: Yup.string()
  // .nullable()
  // .test(
  //   "is-valid-phone",
  //   "Phone number is Invalid",
  //   (value) => {
  //     // Allow empty value (optional field)
  //     if (!value) return true;

  //     // Check if the value starts with +, has only one -, and follows the required format
  //     return /^\+?[0-9]+(-[0-9]+)?$/.test(value) && value.length <= 15;
  //   }
  // ),
  phone: Yup.string()
    // .nullable()
    // .trim()
    // .test(
    //   "is-valid-phone",
    //   "Phone number must be 7-15 digits with optional separators (+, -, (, ), space)",
    //   (value) => {
    //     if (!value) return true; // Allow empty value

    //     // Remove all allowed separators to count digits
    //     const digitsOnly = value.replace(/[\s+\-()]/g, '');
    //     if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

    //     // Check for valid characters and format
    //     return /^[0-9\s+\-()]+$/.test(value) && // Only numbers and allowed separators
    //            !/[\s+\-()]{2,}/.test(value); // No consecutive separators
    //   }
    // ),
    .nullable()
    .trim()
    .test(
      'is-valid-phone',
      'Phone number must be 7-15 digits with optional separators (+, -, (, ), space)',
      (value) => {
        if (!value) return true; // Allow empty

        const digitsOnly = value.replace(/\D/g, '');
        if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

        // Check allowed characters only
        if (!/^[0-9+\-\s()]+$/.test(value)) return false;

        // Reject if two special characters (non-digits) come back-to-back (excluding spaces)
        if (/(?! )[\+\-\(\)]{2,}/.test(value)) return false;

        return true;
      }
    ),
  // mobile: Yup.string()
  // .nullable()

  // .test(
  //   "is-valid-phone",
  //   "Phone number is Invalid",
  //   (value) => {
  //     // Allow empty value (optional field)
  //     if (!value) return true;

  //     // Check if the value starts with +, has only one -, and follows the required format
  //     return /^\+?[0-9]+(-[0-9]+)?$/.test(value) && value.length <= 15;
  //   }
  // ),
  mobile: Yup.string()
    // .nullable()
    // .trim()
    // .test(
    //   "is-valid-phone",
    //   "Phone number must be 7-15 digits with optional separators (+, -, (, ), space)",
    //   (value) => {
    //     if (!value) return true; // Allow empty value

    //     // Remove all allowed separators to count digits
    //     const digitsOnly = value.replace(/[\s+\-()]/g, '');
    //     if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

    //     // Check for valid characters and format
    //     return /^[0-9\s+\-()]+$/.test(value) && // Only numbers and allowed separators
    //            !/[\s+\-()]{2,}/.test(value); // No consecutive separators
    //   }
    // ),
    .nullable()
    .trim()
    .test(
      'is-valid-phone',
      'Phone number must be 7-15 digits with optional separators (+, -, (, ), space)',
      (value) => {
        if (!value) return true; // Allow empty

        const digitsOnly = value.replace(/\D/g, '');
        if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

        // Check allowed characters only
        if (!/^[0-9+\-\s()]+$/.test(value)) return false;

        // Reject if two special characters (non-digits) come back-to-back (excluding spaces)
        if (/(?! )[\+\-\(\)]{2,}/.test(value)) return false;

        return true;
      }
    ),

  // assistantPhone: Yup.string()
  // .nullable()
  // .test(
  //   "is-valid-phone",
  //   "Phone number is Invalid",
  //   (value) => {
  //     // Allow empty value (optional field)
  //     if (!value) return true;

  //     // Check if the value starts with +, has only one -, and follows the required format
  //     return /^\+?[0-9]+(-[0-9]+)?$/.test(value) && value.length <= 15;
  //   }
  // ),
  assistantPhone: Yup.string()
    // .nullable()
    // .trim()
    // .test(
    //   "is-valid-phone",
    //   "Phone number must be 7-15 digits with optional separators (+, -, (, ), space)",
    //   (value) => {
    //     if (!value) return true; // Allow empty value

    //     // Remove all allowed separators to count digits
    //     const digitsOnly = value.replace(/[\s+\-()]/g, '');
    //     if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

    //     // Check for valid characters and format
    //     return /^[0-9\s+\-()]+$/.test(value) && // Only numbers and allowed separators
    //            !/[\s+\-()]{2,}/.test(value); // No consecutive separators
    //   }
    // ),
    .nullable()
    .trim()
    .test(
      'is-valid-phone',
      'Phone number must be 7-15 digits with optional separators (+, -, (, ), space)',
      (value) => {
        if (!value) return true; // Allow empty

        const digitsOnly = value.replace(/\D/g, '');
        if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

        // Check allowed characters only
        if (!/^[0-9+\-\s()]+$/.test(value)) return false;

        // Reject if two special characters (non-digits) come back-to-back (excluding spaces)
        if (/(?! )[\+\-\(\)]{2,}/.test(value)) return false;

        return true;
      }
    ),
  street: Yup.string()
    .nullable()
    .trim() // Automatically trim leading and trailing spaces
    .max(100, 'Street cannot exceed 100 characters.')
    .test('valid-characters', 'Invalid characters in street.', (value) => {
      if (!value) return true; // Allow blank input
      // Regex to validate allowed characters and ensure no consecutive special characters or spaces
      return /^[A-Za-z0-9 ,.#/'-]+$/.test(value) && !/( {2,}|[,.#/'-]{2,})/.test(value);
    }),

  city: Yup.string()
    .nullable()
    .trim() // Automatically trim leading and trailing spaces
    .max(50, 'City cannot exceed 50 characters.')
    .test('valid-characters', 'Please enter valid city', (value) => {
      if (!value) return true; // Allow blank input
      return /^[A-Za-z\s'-.]+$/.test(value);
    }),

  state: Yup.string()
    .nullable()
    .trim() // Automatically trim leading and trailing spaces
    .max(50, 'State cannot exceed 50 characters.')
    .test('valid-characters', 'Please enter valid state.', (value) => {
      if (!value) return true; // Allow blank input
      return /^[A-Za-z\s-]+$/.test(value);
    }),

  country: Yup.string()
    .nullable()
    .trim()
    .test('valid-country', 'Country should only contain alphabets and hyphens', (value) => {
      if (!value) return true; // Allow blank input
      // Allow alphabets, spaces and single hyphens
      return (
        /^[A-Za-z\s-]+$/.test(value) && // Only alphabets, spaces and hyphens
        !/--/.test(value) && // No consecutive hyphens
        !/^-|-$/.test(value)
      ); // No leading/trailing hyphens
    }),

  zipCode: Yup.string()
    .nullable()
    .trim()
    .test(
      'is-valid-zip-code',
      'ZIP code must be 3-10 characters with only letters, numbers and hyphens',
      (value) => {
        if (!value) return true; // Allow empty value

        // Check for valid characters and length
        return (
          /^[A-Za-z0-9-]{3,10}$/.test(value) && // Only letters, numbers, hyphen
          !/--/.test(value)
        ); // No consecutive hyphens
      }
    ),
});
